<template>
  <main>
    <GridWrapper>
      <SectionSet is-first>
        <GridsTwelveGrid>
          <BreadCrumbs class="col-span-3 col-start-1 leading-[1.7] laptop:col-start-2" />
          <h1 class="col-span-6 col-start-1 row-start-2 leading-[1.7] laptop:col-span-6 laptop:col-start-2">
            {{ productTypes?.productsPage?.data?.attributes?.hero_title }}
          </h1>
          <p class="col-span-6 col-start-1 row-start-3 italic leading-[1.7] laptop:col-span-5 laptop:col-start-2">
            {{ productTypes?.productsPage?.data?.attributes?.hero_subtitle }}
          </p>
          <ProductsProductTypesGrid
            :productTypes="productTypes"
            class="col-span-6 col-start-1 row-start-4 mt-12 laptop:col-span-12 laptop:col-start-1 laptop:mt-14"
          />
        </GridsTwelveGrid>
      </SectionSet>

      <LeafAnimation />
      <SectionSet class="hidden laptop:block">
        <Stepper class="col-span-6 col-start-1 row-start-5 mt-12 laptop:col-span-12 laptop:col-start-1 laptop:mt-14">
          <StepperStep
            v-for="step in productTypes?.processSteps?.data?.attributes?.process_steps"
            :step="step?.step"
            :key="JSON.stringify(step)"
            :img="step?.image?.data?.attributes?.url"
            :subtitle="step?.text"
          />
        </Stepper>
      </SectionSet>
    </GridWrapper>
    <SectionSet class="laptop:hidden">
      <StepperSlider :processSteps="productTypes" class="col-span-6 col-start-1 row-start-5 laptop:hidden" />
    </SectionSet>

    <GridsOutterGrid>
      <SectionSet isLast class="col-span-3 col-start-1 desktop:col-span-1 desktop:col-start-2">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 col-start-1 laptop:col-span-10 laptop:col-start-2">
            <SliderBrands
              :products="productTypes?.products?.data"
              :title="$t('take-a-look-at-our-pre-packaged-products')"
              :buttonText="productTypes?.productsPage?.data?.attributes?.promoted_title"
              :link="localePath({ name: 'brands' })"
            />
          </div>
        </div>
      </SectionSet>
    </GridsOutterGrid>
  </main>
</template>
<script setup lang="ts">
const { t: $t } = useI18n();

const pageTitle = ref<string | null>(null);

const localePath = useLocalePath();

const { locale, finalizePendingLocaleChange } = useI18n();

await finalizePendingLocaleChange();

const { data: productTypes } = await useAsyncGql({
  operation: "GetProductTypes",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

watch(
  productTypes,
  (newVal) => {
    if (newVal) {
      if (newVal.productsPage?.data?.attributes?.seo?.metaTitle) {
        pageTitle.value = newVal.productsPage?.data?.attributes?.seo?.metaTitle;
      }
      useHead({
        title: () => pageTitle.value,
      });
      useServerSeoMeta({
        title: () => `${newVal.productsPage?.data?.attributes?.seo?.metaTitle}`,
        ogTitle: () => `${newVal.productsPage?.data?.attributes?.seo?.metaTitle}`,
        description: () => `${newVal.productsPage?.data?.attributes?.seo?.metaDescription}`,
        ogDescription: () => `${newVal.productsPage?.data?.attributes?.seo?.metaDescription}`,
        ogImage: () => `${newVal.productsPage?.data?.attributes?.seo?.metaImage?.data?.attributes?.url}`,
      });
    }
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped></style>
